import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';

/**
 * Angular default url serializer is interpreting + as space
 * More: https://stackoverflow.com/questions/45428842/angular-url-plus-sign-converting-to-space
 */
export default class CustomUrlSerializer implements UrlSerializer {
  private _defaultUrlSerializer: DefaultUrlSerializer = new DefaultUrlSerializer();

  parse(url: string): UrlTree {
    // Encode "+" to "%2B"
    url = url.replace(/\+/gi, '%2B');
    // Use the default serializer.
    return this._defaultUrlSerializer.parse(url);
  }

  serialize(tree: UrlTree): string {
    return this._defaultUrlSerializer.serialize(tree).replace(/\+/gi, '%2B');
  }
}
